import { css } from "@emotion/react";
import tokens from "@kibela/design-tokens";

import { fontSize } from "~/client/styles/emotion/mixins/fontSize";
import { size } from "~/client/styles/emotion/mixins/size";

export const rootStyle = css({
  listStyle: "none",
  borderBottom: `1px solid ${tokens.color.border.secondary.value}`,
  color: tokens.color.text.primary.default.value,
  ":last-child": {
    borderBottom: "none",
  },
});

export const contentStyle = css({
  display: "grid",
  gridTemplate: `
    "icon title" auto
    "icon message" auto
    "icon date" auto
    / 40px 1fr;
  `,
  gap: "5px 12px",
  alignItems: "start",
  padding: "12px 15px 12px 10px",
  backgroundColor: "inherit",
});

export const titleStyle = css([
  fontSize(14),
  {
    gridArea: "title",
    lineHeight: "1.4",
  },
]);

export const iconStyle = css({
  gridArea: "icon",
  display: "flex",
  alignItems: "center",
  gap: "6px",
});

export const notificationKindStyle = css([
  size("28px"),
  {
    flexShrink: "0",
  },
]);

export const notificationKindEmojiStyle = css([fontSize(26)]);

export const messageStyle = css([
  fontSize(12),
  {
    gridArea: "message",
    color: tokens.color.text.tertiary.default.value,
    lineHeight: "1.5",
  },
]);

export const startAtStyle = css([
  fontSize(12),
  {
    gridArea: "date",
    color: tokens.color.text.tertiary.default.value,
  },
]);

export const emptyStyle = css([
  fontSize(14),
  {
    display: "flex",
    justifyContent: "center",
    color: tokens.color.text.primary.default.value,
    padding: "20px 0",
  },
]);
